/**
 * Enum object for all possible {@link Feature} IDs
 */
export enum FeatureID {
  LoginOnBehalfOf = 'loginOnBehalfOf',
  AdministratorOf = 'administratorOf',
  CanDelete = 'canDelete',
  CanEditMetadata = 'canEditMetadata',
  WithdrawItem = 'withdrawItem',
  ReinstateItem = 'reinstateItem',
  EPersonRegistration = 'epersonRegistration',
  CanManageGroups = 'canManageGroups',
  CanManageGroup = 'canManageGroup',
  IsCollectionAdmin = 'isCollectionAdmin',
  IsCommunityAdmin = 'isCommunityAdmin',
  CanDownload = 'canDownload',
  CanManageVersions = 'canManageVersions',
  CanManageBitstreamBundles = 'canManageBitstreamBundles',
  CanManageRelationships = 'canManageRelationships',
  CanManageMappings = 'canManageMappings',
  CanManagePolicies = 'canManagePolicies',
  CanMakePrivate = 'canMakePrivate',
  CanMove = 'canMove',
}
